import React from "react";
import { InitialValuesProps } from "../../models/ticket";
import { formatCurrency } from "../../utils/formatCurrency";

interface Step4Props {
  values: InitialValuesProps;
}

function Step4({ values }: Step4Props) {
  return (
    <div className="confirmData">
      <h2>Dados Pessoais</h2>

      <div className="row mt-2">
        <div className="col-12 col-md-4">
          <div className="detailItem">
            <span>Nome Completo</span>
            <span>{values.name}</span>
          </div>
        </div>
        <div className="col-12 col-md-4">
          <div className="detailItem">
            <span>Nascimento</span>
            <span>{values.birthDate}</span>
          </div>
        </div>
        <div className="col-12 col-md-4">
          <div className="detailItem">
            <span>CPF</span>
            <span>{values.cpf}</span>
          </div>
        </div>
      </div>

      <div className="row mt-2 mb-3">
        <div className="col-12 col-md-6 ">
          <div className="detailItem">
            <span>Telefone</span>
            <span>{values.phone}</span>
          </div>
        </div>
        <div className="col-12 col-md-6">
          <div className="detailItem">
            <span>E-mail</span>
            <span>{values.email}</span>
          </div>
        </div>
      </div>

      <h2>Endereço</h2>

      <div className="detailItem mt-2">
        <span>{`${values.street}, ${values.neighborhood}, ${values.number}, ${
          values.cep
        }, ${values.city} - ${values.state} ${
          values.addressComplement ? ", " + values.addressComplement : ""
        }`}</span>
      </div>

      <h2>Produtos</h2>

      {values.productList.map(({ id, name, price, quantity }) => (
        <div className="listItem" key={id}>
          <div>
            <p className="title">{`${quantity}x ${name}`}</p>
            <p className="price">{formatCurrency(price)}</p>
          </div>
        </div>
      ))}
    </div>
  );
}

export { Step4 };
